import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/bastrop")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Bastrop, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Bastrop & Bastrop County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Bastrop, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Bastrop and Bastrop County.",
      keywords: "awnings Bastrop, awning company Bastrop, custom awnings Bastrop, sail shades Bastrop, patio covers Bastrop, pergola covers Bastrop, metal awnings Bastrop, canvas awnings Bastrop, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Bastrop", "Bastrop County"),
  }),
  component: () => <CityHomePage city="Bastrop" region="Bastrop County" />,
});
